import React from 'react';
import { MagnifyingGlass } from '@phosphor-icons/react';

/**
 * Universal search bar with a fixed magnifier on the left.
 * Usage: <SearchBar value={q} onChange={setQ} placeholder="..." />
 */
export const SearchBar = ({ value, onChange, placeholder = 'Rechercher…', dataTestId = 'search-bar-input', style = {}, autoFocus = false }) => {
  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'stretch',
        background: 'white',
        border: '1px solid #E2E2E6',
        borderRadius: 8,
        overflow: 'hidden',
        height: 38,
        ...style,
      }}
      data-testid="search-bar"
    >
      <div
        aria-hidden="true"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 38,
          background: '#F4F5F7',
          borderRight: '1px solid #E2E2E6',
          flexShrink: 0,
        }}
      >
        <MagnifyingGlass size={16} weight="bold" color="#5E5F66" />
      </div>
      <input
        type="text"
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        autoFocus={autoFocus}
        data-testid={dataTestId}
        style={{
          flex: 1,
          border: 'none',
          outline: 'none',
          padding: '0 12px',
          fontSize: '0.92rem',
          background: 'transparent',
        }}
      />
    </div>
  );
};

export default SearchBar;
